export { default as ScrollResistantNumberInput } from './ScrollResistantNumberInput';